import DeepDiff from 'deep-diff'
import { GLMappingService } from '../../services'

function invokeMethod(obj, functionName, ...args) {
  return obj[functionName].apply(obj, args)
}

const state = {
  baseIndex: 0,
  currentIndex: 0,
  snapshots: []
}

const getters = {
  baseSnapshot: (state) => state.snapshots[state.baseIndex],
  currentSnapshot: (state) => state.snapshots[state.currentIndex],
  snapshotDiff: (state) => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  }
}

const actions = {
  async getStoreItem({ commit }, { serviceFunction, params = null }) {
    // const entity = await GLMappingService.getGLRoutingList()
    const entity = await invokeMethod(GLMappingService, serviceFunction, params)
    commit('saveInitialSnapshots', entity)
    return entity
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    commit('clearSnapshots')
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
